import { uploadVideoMultiPart } from "smartassess-api-lib";
import {
  ab2b64,
  b642ab,
  generateDecryptKey,
  generateEncryptionKeyApi,
  getDecryptFile,
  importAesKey,
} from "../../service/EncryptionApi/EncryptionApi";

export const videoUploader = async (
  blob: any,
  path?: string,
  fileExtension?: string,
) => {
  const fileData = [];
  fileData.push(blob);

  const jsonData = {
    file: fileData,
    path,
    startUploadEndPoint: "s3Upload/startUpload",
    getPresignedEndPoint: "s3Upload/generatePresigned",
    completeUploadEndPoint: "s3Upload/completeUpload",
    fileExtension: fileExtension ? fileExtension : "webm",
  };
  const imageData = await uploadVideoMultiPart(jsonData);
  return imageData?.data?.data;
};

// function to upload encrypted file as blob form
export const uploadEncryptedBlob = async (
  blob: any,
  path?: string,
  fileExtension?: string,
) => {
  const generateEncryptionRespons = await generateEncryptionKeyApi();
  const iv = crypto.getRandomValues(
    new Uint8Array(generateEncryptionRespons.ivLength || 12),
  );
  const ivB64 = ab2b64(iv.buffer);
  const meta = {
    encryptedkey: generateEncryptionRespons.encryptedKeyBase64,
    iv: ivB64,
    algo: generateEncryptionRespons.algo,
  };
  const key = await importAesKey(generateEncryptionRespons.plaintextKeyBase64);
  const buf = await blob.arrayBuffer();
  const ciphertext = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    buf,
  );
  const fileData = [];
  fileData.push(new Blob([ciphertext], { type: "image/png" }));
  const jsonData = {
    file: fileData,
    path,
    startUploadEndPoint: "s3Upload/startUpload",
    getPresignedEndPoint: "s3Upload/generatePresigned",
    completeUploadEndPoint: "s3Upload/completeUpload",
    fileExtension: fileExtension ? fileExtension : "webm",
    meta,
  };
  const imageData = await uploadVideoMultiPart(jsonData);
  return imageData?.data?.data;
};

// function to decrypt and download encrypted file
export const handleDownloadEncryptFile = async (
  fileName: string,
  setLoading: (loading: boolean) => void,
  downloadFileName: string,
) => {
  setLoading(true);
  try {
    const res = await getDecryptFile(fileName);
    const meta = res?.data;
    const encResp = await fetch(meta.getUrl);
    const encBuf = await encResp.arrayBuffer();
    const decRes = await generateDecryptKey(meta.encryptedKeyBase64);
    const { plaintextKeyBase64 } = decRes.data;
    const key = await importAesKey(plaintextKeyBase64);
    const iv = new Uint8Array(b642ab(meta.ivBase64));
    const plainBuf = await crypto.subtle.decrypt(
      { name: meta.algo, iv },
      key,
      encBuf,
    );
    const blob = new Blob([plainBuf], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    // if downloadFileName contains extension then no need to append extension
    const a = document.createElement("a");
    a.href = url;
    if (downloadFileName?.includes(".")) {
      a.download = (downloadFileName || "file").replace(/\.enc$/, "");
      document.body.appendChild(a);
    } else {
      const fileExtension = fileName.split(".")[1];
      a.download = (downloadFileName + "." + fileExtension || "file").replace(
        /\.enc$/,
        "",
      );
      document.body.appendChild(a);
    }
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err: any) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};
